export const fifteenMinuteOptions = [
  {
    displayName: '0:00',
    value: 0,
  },
  {
    displayName: '0:05',
    value: 5,
  },
  {
    displayName: '0:10',
    value: 10,
  },
];

export const thirtyMinuteOptions = [
  {
    displayName: '0:00',
    value: 0,
  },
  {
    displayName: '0:05',
    value: 5,
  },
  {
    displayName: '0:10',
    value: 10,
  },

  {
    displayName: '0:15',
    value: 15,
  },
  {
    displayName: '0:20',
    value: 20,
  },
  {
    displayName: '0:25',
    value: 25,
  },
];

export const hourlyOptions = [
  {
    displayName: '0:00',
    value: 0,
  },
  {
    displayName: '0:05',
    value: 5,
  },
  {
    displayName: '0:10',
    value: 10,
  },

  {
    displayName: '0:15',
    value: 15,
  },
  {
    displayName: '0:20',
    value: 20,
  },
  {
    displayName: '0:25',
    value: 25,
  },

  {
    displayName: '0:30',
    value: 30,
  },
  {
    displayName: '0:35',
    value: 35,
  },
  {
    displayName: '0:40',
    value: 40,
  },

  {
    displayName: '0:45',
    value: 45,
  },
  {
    displayName: '0:50',
    value: 50,
  },
  {
    displayName: '0:55',
    value: 55,
  },
];
